// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.mbmiOtbuZ2WxOL {
  color: var(--ds-text-subtlest, #626f86);
}
.xsISqZ3wUhPCVQ {
  display: block;
  max-width: 600px;
  margin: var(--ds-space-1000, 80px) auto;
  text-align: center;
}
.xsISqZ3wUhPCVQ h1 {
  margin-bottom: var(--ds-space-150, 12px);
  font-size: 26px;
}
.xsISqZ3wUhPCVQ p {
  font-size: 18px;
  line-height: 22px;
}
.ZN275aYGEcr36q {
  margin-top: var(--ds-space-400, 32px);
}
`, ""]);
// Exports
export var quiet = `mbmiOtbuZ2WxOL`;
export var bigMessage = `xsISqZ3wUhPCVQ`;
export var tryAgainButton = `ZN275aYGEcr36q`;
export default ___CSS_LOADER_EXPORT___;
